export default __webpack_public_path__ + "static/media/Icon-download.263d8264.svg";